module.exports = __webpack_public_path__ + "static/media/ChevronDown.84ddcd4c.svg";